import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const SIZES = ["xs", "sm", "md", "lg", "xl"];

const PriceBlurWrapper = ({ children, isLoading = false, showSpinner = true, size = "md" }) => (
    <span className="pbw">
        <span className={`pbw__content${isLoading ? " pbw__content--blur" : ""}`}>
            {children}
        </span>
        {isLoading && showSpinner && (
            <span className="pbw__spinner-overlay" aria-hidden="true">
                <span className={`pbw__spinner pbw__spinner--${size}`} />
            </span>
        )}
    </span>
);

PriceBlurWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    isLoading: PropTypes.bool,
    showSpinner: PropTypes.bool,
    size: PropTypes.oneOf(SIZES),
};


export default PriceBlurWrapper;
